export var RepositoryRef;
(function (RepositoryRef) {
    RepositoryRef["REPOSITORY_REF_DEFAULT"] = "DEFAULT";
    RepositoryRef["REPOSITORY_REF_DRAFT"] = "DRAFT";
    RepositoryRef["REPOSITORY_REF_COMMIT"] = "COMMIT";
})(RepositoryRef || (RepositoryRef = {}));
